/* eslint-disable */
import { combineReducers, } from 'redux';

import active from './active';
import list from './list';

export default combineReducers({
  active,
  list,
});